import { erpAxios } from '.';

const getAllRequestReplacementLoans = async (id, client) => {
  const { data } = await erpAxios.get(`/loan/getAllRequestReplacementLoans/${id}`);
  return data;
};

export default getAllRequestReplacementLoans;
